export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT = 'LOGOUT';
export const FETCHED_ACTIVE_STUDIES = 'FETCHED_ACTIVE_STUDIES';
export const FETCHING_ACTIVE_STUDIES = 'FETCHING_ACTIVE_STUDIES';
export const FETCH_ACTIVE_STUDIES_ERROR = 'FETCH_ACTIVE_STUDIES_ERROR';

export const FETCHED_DELEGATION_LOG = 'FETCHED_DELEGATION_LOG';
export const FETCHING_DELEGATION_LOG = 'FETCHING_FETCHED_DELEGATION_LOG';
export const FETCH_DELEGATION_LOG_ERROR = 'FETCH_DELEGATION_LOG_ERROR';

export const ERROR_DELEGATIONLOG_EXPORT_CSV = 'ERROR_DELEGATIONLOG_EXPORT_CSV';
export const FETCHING_DELEGATIONLOG_EXPORT_CSV = 'FETCHING_DELEGATIONLOG_EXPORT_CSV';
export const RECEIVE_DELEGATIONLOG_EXPORT_CSV = 'RECEIVE_DELEGATIONLOG_EXPORT_CSV';

export const RECEIVED_UNASSIGNED_STUDIES = 'RECEIVED_UNASSIGNED_STUDIES';
export const RECEIVED_UNASSIGNED_STUDIES_ERROR = 'RECEIVED_UNASSIGNED_STUDIES_ERROR';

export const ERROR_CSV = 'ERROR_CSV';
export const FETCHING_CSV = 'FETCHING_CSV';
export const RECEIVE_CSV = 'RECEIVE_CSV';
export const CLEAR_ERROR_OR_DATA = 'CLEAR_ERROR_OR_DATA';

export const FETCHING_PEOPLE = 'FETCHING_PEOPLE';
export const RECEIVE_PEOPLE = 'RECEIVE_PEOPLE';
export const ERROR_PEOPLE = 'ERROR_PEOPLE';
export const PUBLISH_PEOPLE_COUNT = 'PUBLISH_PEOPLE_COUNT';

export const RECEIVE_ORGANIZATIONS = 'RECEIVE_ORGANIZATIONS';
export const RECEIVE_TOTAL = 'RECEIVE_TOTAL';

export const SAVING_ASSIGNEMENT = 'SAVING_ASSIGNEMENT';
export const SAVED_ASSIGNEMENT = 'SAVED_ASSIGNEMENT';
export const SAVE_ASSIGNEMENT_ERROR = 'SAVE_ASSIGNEMENT_ERROR';
export const DELETING_ASSIGNEMENT = 'DELETING_ASSIGNEMENT';
export const DELETE_ASSIGNEMENT_ERROR = 'DELETE_ASSIGNEMENT_ERROR';
export const VALIDATION_ERROR = 'VALIDATION_ERROR';
export const UPDATING_PHI_CONSENT = 'UPDATING_PHI_CONSENT';
export const UPDATE_PHI_CONSENT = 'UPDATE_CONSENT_AND_PHI';
export const UPDATING_PHI_CONSENT_FAILED = 'UPDATING_PHI_CONSENT_FAILED';

export const PUBLISH_PERMISSION_MATRIX = 'PUBLISH_PERMISSION_MATRIX';
export const RECEIVED_USER_ROLES_FOR_SPONSOR = 'RECEIVED_USER_ROLES_FOR_SPONSOR';
export const RECEIVED_USER_ROLES_FOR_SPONSOR_ERROR = 'RECEIVED_USER_ROLES_FOR_SPONSOR_ERROR';
export const FETCHING_ROLES = 'FETCHING_ROLES';
export const RECEIVED_ROLES = 'RECEIVED_ROLES';
export const RECEIVED_ROLES_ERROR = 'RECEIVED_ROLES_ERROR';
export const PUBLISH_STUDY_GID = 'PUBLISH_STUDY_GID';

export const FETCHING_PARTICIPANTS = 'FETCHING_PARTICIPANTS';
export const RECEIVE_PARTICIPANTS = 'RECEIVE_PARTICIPANTS';
export const ERROR_PARTICIPANTS = 'ERROR_PARTICIPANTS';

export const PUBLISH_NOTES_STUDY_GID_AND_PARTICIPANT_ID = 'PUBLISH_NOTES_STUDY_GID_AND_PARTICIPANT_ID';

export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';
export const SHOW_MIGRATION_MODAL = 'SHOW_MIGRATION_MODAL';
export const HIDE_MIGRATION_MODAL = 'HIDE_MIGRATION_MODAL';
export const SHOW_MIGRATION_MODAL_SUCCESS = 'SHOW_MIGRATION_MODAL_SUCCESS';
export const HIDE_MIGRATION_MODAL_SUCCESS = 'HIDE_MIGRATION_MODAL_SUCCESS';
export const SHOW_MIGRATION_MODAL_ERROR = 'SHOW_MIGRATION_MODAL_ERROR';
export const HIDE_MIGRATION_MODAL_ERROR = 'HIDE_MIGRATION_MODAL_ERROR';

export const SELECT_SPONSOR = 'SELECT_SPONSOR';
export const UPDATE_SPONSOR_SELECTION = 'UPDATE_SPONSOR_SELECTION';
export const SELECT_SPONSOR_ERROR = 'SELECT_SPONSOR_ERROR';
export const USER_ALLOCATIONS_ERROR = 'USER_ALLOCATIONS_ERROR';

export const FETCHING_TENANT_COOKIE = 'FETCHING_TENANT_COOKIE';
export const FETCHED_TENANT_COOKIE = 'FETCHED_TENANT_COOKIE';
export const ERROR_FETCHING_TENANT_COOKIE = 'ERROR_FETCHING_TENANT_COOKIE';

export const FETCHING_USER_DETAILS_PENDING = 'FETCHING_USER_DETAILS_PENDING';
export const FETCHING_USER_DETAILS_SUCCESS = 'FETCHING_USER_DETAILS_SUCCESS';
export const FETCHING_USER_DETAILS_FAIL = 'FETCHING_USER_DETAILS_FAIL';

export const FETCHING_DOCUMENTS = 'FETCHING_DOCUMENTS';
export const RECEIVE_DOCUMENTS = 'RECEIVE_DOCUMENTS';
export const ERROR_DOCUMENTS = 'ERROR_DOCUMENTS';
export const PUBLISH_DOCUMENTS_STUDY_GID_AND_PARTICIPANT_ID = 'PUBLISH_DOCUMENTS_STUDY_GID_AND_PARTICIPANT_ID';

export const FETCHING_PDF = 'FETCHING_PDF';
export const RECEIVE_PDF = 'RECEIVE_PDF';
export const CLOSE_DOCUMENT_PDF = 'CLOSE_DOCUMENT_PDF';
export const ERROR_PDF = 'ERROR_PDF';

export const FETCHING_JOURNAL_PDF = 'FETCHING_JOURNAL_PDF';
export const RECEIVE_JOURNAL_PDF = 'RECEIVE_JOURNAL_PDF';
export const CLOSE_JOURNAL_PDF = 'CLOSE_JOURNAL_PDF';
export const ERROR_JOURNAL_PDF = 'ERROR_JOURNAL_PDF';

export const FETCHING_NOTES_PDF = 'FETCHING_NOTES_PDF';
export const FETCHED_NOTES_PDF = 'FETCHED_NOTES_PDF';
export const FETCH_NOTES_ERROR = 'FETCH_NOTES_ERROR';

export const SET_CLIENT_CONFIGURATION = 'SET_CLIENT_CONFIGURATION';

export const PUBLISH_SUBJECT_INFORMATION = 'PUBLISH_SUBJECT_INFORMATION';

export const FETCHING_SUBJECT_PHI_INFORMATION = 'FETCHING_SUBJECT_PHI_INFORMATION';
export const FETCHED_SUBJECT_PHI_INFORMATION = 'FETCHED_SUBJECT_PHI_INFORMATION';
export const FETCH_SUBJECT_PHI_INFORMATION_ERROR = 'FETCH_SUBJECT_PHI_INFORMATION_ERROR';
export const PUBLISH_PHI_STUDY_GID_AND_PARTICIPANT_ID = 'PUBLISH_PHI_STUDY_GID_AND_PARTICIPANT_ID';

export const FETCHING_STUDY_INFORMATION = 'FETCHING_STUDY_INFORMATION';
export const FETCHED_STUDY_INFORMATION = 'FETCHED_STUDY_INFORMATION';
export const FETCH_STUDY_INFORMATION_ERROR = 'FETCH_STUDY_INFORMATION_ERROR';

export const FETCHING_SITE_INFORMATION = 'FETCHING_SITE_INFORMATION';
export const FETCHED_SITE_INFORMATION = 'FETCHED_SITE_INFORMATION';
export const FETCH_SITE_INFORMATION_ERROR = 'FETCH_SITE_INFORMATION_ERROR';

export const CREATE_NEW_NOTE = 'CREATE_NEW_NOTE';
export const FETCHING_CONSENT_DOCUMENTS_FOR_PARTICIPANT = 'FETCHING_CONSENT_DOCUMENTS_FOR_PARTICIPANT';
export const FETCHED_CONSENT_DOCUMENTS_FOR_PARTICIPANT = 'FETCHED_CONSENT_DOCUMENTS_FOR_PARTICIPANT';
export const FETCH_CONSENT_DOCUMENTS_FOR_PARTICIPANT_ERROR = 'FETCH_CONSENT_DOCUMENTS_FOR_PARTICIPANT_ERROR';
export const PUBLISH_DOCUMENTS_METADATA_FOR_ADD_NOTES = 'PUBLISH_DOCUMENTS_METADATA_FOR_ADD_NOTES';
export const CLEAR_NEW_NOTE_FORM = 'CLEAR_NEW_NOTE_FORM';
export const UPDATE_ADD_NOTE_CONSENT_GID = 'UPDATE_ADD_NOTE_CONSENT_GID';
export const POST_NEW_NOTE = 'POST_NEW_NOTE';
export const POST_NEW_NOTE_ERROR = 'POST_NEW_NOTE_ERROR';
export const CHANGE_TAB = 'CHANGE_TAB';
export const SHOW_ADD_NOTE_HIDE_VIEW = 'SHOW_ADD_NOTE_HIDE_VIEW';

export const FETCHING_HELPDESK_PHONENO = 'FETCHING_HELPDESK_PHONENO';
export const FETCHED_HELPDESK_PHONENO = 'FETCHED_HELPDESK_PHONENO';
export const FETCH_DEFAULT_HELPDESK_PHONENO = 'FETCH_DEFAULT_HELPDESK_PHONENO';

export const DOCUMENT_STATUS_VIEW__HIDE = 'DOCUMENT_STATUS_VIEW__HIDE';
export const DOCUMENT_STATUS_VIEW__SHOW = 'DOCUMENT_STATUS_VIEW__SHOW';
export const DOCUMENT_STATUS_VIEW__ERROR = 'DOCUMENT_STATUS_VIEW__ERROR';
export const DOCUMENT_STATUS_VIEW__LOADING = 'DOCUMENT_STATUS_VIEW__LOADING';
export const DOCUMENT_STATUSES__FETCH = 'DOCUMENT_STATUSES__FETCH';
export const DOCUMENT_STATUS__SAVE = 'DOCUMENT_STATUS__SAVE';

export const PUBLISH_CONSENTGID_AND_CONSENTINGGID_FOR_JOURNAL = 'PUBLISH_CONSENTGID_AND_CONSENTINGGID_FOR_JOURNAL';
export const CLEAR_JOURNAL_FORM = 'CLEAR_JOURNAL_FORM';
export const JOURNAL_DOCUMENT_SELECTED = 'JOURNAL_DOCUMENT_SELECTED';
export const FETCHING_CONSENTING_JOURNAL = 'FETCHING_CONSENTING_JOURNAL';
export const FETCHED_CONSENTING_JOURNAL = 'FETCHED_CONSENTING_JOURNAL';
export const FETCH_CONSENTING_JOURNAL_ERROR = 'FETCH_CONSENTING_JOURNAL_ERROR';
export const FETCHING_CONSENTING = 'FETCHING_CONSENTING';
export const FETCHED_CONSENTING = 'FETCHED_CONSENTING';
export const FETCH_CONSENTING_ERROR = 'FETCH_CONSENTING_ERROR';

export const PARTICIPANT_STATUS_VIEW_HIDE = 'PARTICIPANT_STATUS_VIEW_HIDE';
export const PARTICIPANT_STATUS_VIEW_LOADING = 'PARTICIPANT_STATUS_VIEW_LOADING';
export const PARTICIPANT_STATUS_VIEW_ERROR = 'PARTICIPANT_STATUS_VIEW_ERROR';
export const PARTICIPANT_STATUS_FETCH = 'PARTICIPANT_STATUS_FETCH';

export const FETCHING_MONITORS_ERROR = 'FETCHING_MONITORS_ERROR';
export const FETCHED_MONITORS = 'FETCHED_MONITORS';
export const FETCHING_MONITORS = 'FETCHING_MONITORS';
export const PUBLISH_MONITOR_COUNT = 'PUBLISH_MONITOR_COUNT';

export const DATA_ERROR = 'DATA_ERROR';
export const DATA_LOADING = 'DATA_LOADING';
export const USER_ASSIGNMENTS__FETCH = 'USER_ASSIGNMENTS__FETCH';
export const LOGGED_USER_FETCH = 'LOGGED_USER_FETCH';
export const LOGGED_USER_FETCH_ERROR = 'LOGGED_USER_FETCH_ERROR';

export const FETCHING_USER_DETAILS = 'FETCHING_USER_DETAILS';
export const FETCHED_USER_DETAILS = 'FETCHED_USER_DETAILS';
export const FETCH_USER_DETAILS_ERROR = 'FETCH_USER_DETAILS_ERROR';

export const FETCHED_PARTICIPANT_STATUSES = 'FETCHED_PARTICIPANT_STATUSES';

export const FETCHING_STUDY_DETAILS_ERROR = 'FETCHING_STUDY_DETAILS_ERROR';
export const FETCHED_STUDY_DETAILS = 'FETCHED_STUDY_DETAILS';
export const FETCHING_STUDY_DETAILS = 'FETCHING_STUDY_DETAILS';

export const UPDATE_PARTICIPANT_JOURNEY_ERROR = 'UPDATE_PARTICIPANT_JOURNEY_ERROR';
export const CLEAR_UPDATE_ERROR = 'CLEAR_UPDATE_ERROR';
export const UPDATED_PARTICIPANT_JOURNEY = 'UPDATED_PARTICIPANT_JOURNEY';

export const FETCHING_PARTICIPANT_JOURNEY = 'FETCHING_PARTICIPANT_JOURNEY';
export const FETCHED_PARTICIPANT_JOURNEY = 'FETCHED_PARTICIPANT_JOURNEY';
export const FETCH_PARTICIPANT_JOURNEY_ERROR = 'FETCH_PARTICIPANT_JOURNEY_ERROR';

export const FETCHING_ORGANIZATIONS_ERROR = 'FETCHING_ORGANIZATIONS_ERROR';
export const FETCHED_ORGANIZATIONS = 'FETCHED_ORGANIZATIONS';
export const FETCHING_ORGANIZATIONS = 'FETCHING_ORGANIZATION';

export const PUBLISH_PARTICIPANTS_FILTER = 'PUBLISH_PARTICIPANTS_FILTER';
export const RESET_PARTICIPANTS_FILTER = 'RESET_PARTICIPANTS_FILTER';

export const FETCHING_PARTICIPANT_JOURNAL = 'FETCHING_PARTICIPANT_JOURNAL';
export const FETCHED_PARTICIPANT_JOURNAL = 'FETCHED_PARTICIPANT_JOURNAL';
export const FETCH_PARTICIPANT_JOURNAL_ERROR = 'FETCH_PARTICIPANT_JOURNAL_ERROR';

export const FETCHING_PARTICIPANT_JOURNAL_PDF = 'FETCHING_PARTICIPANT_JOURNAL_PDF';
export const ERROR_PARTICIPANT_JOURNAL_PDF = 'ERROR_PARTICIPANT_JOURNAL_PDF';
export const RECEIVE_PARTICIPANT_JOURNAL_PDF = 'RECEIVE_PARTICIPANT_JOURNAL_PDF';

export const FETCHED_AVAILABLE_DOCUMENTS = 'FETCHED_AVAILABLE_DOCUMENTS';
export const FETCHING_AVAILABLE_DOCUMENTS = 'FETCHING_AVAILABLE_DOCUMENTS';
export const FETCH_AVAILABLE_DOCUMENTS_ERROR = 'FETCH_AVAILABLE_DOCUMENTS_ERROR';

export const ASSIGNING_PARTICIPANT_DOCUMENT = 'ASSIGNING_PARTICIPANT_DOCUMENT';
export const ASSIGN_PARTICIPANT_DOCUMENT_ERROR = 'ASSIGN_PARTICIPANT_DOCUMENT_ERROR';
export const DELETE_PARTICIPANT_DOCUMENT_ERROR = 'DELETE_PARTICIPANT_DOCUMENT_ERROR';
export const CLEAR_DOCUMENTS = 'CLEAR_DOCUMENTS';

export const FETCHING_PRODUCTION_TENANT_FOR_UAT = 'FETCHING_PRODUCTION_TENANT_FOR_UAT';
export const FETCHING_PRODUCTION_TENANT_FOR_UAT_ERROR = 'FETCHING_PRODUCTION_TENANT_FOR_UAT_ERROR';
export const FETCHED_PRODUCTION_TENANT_FOR_UAT = 'FETCHED_PRODUCTION_TENANT_FOR_UAT';

export const UPDATED_PARTICIPANT_EMAIL = 'UPDATED_PARTICIPANT_EMAIL';
export const UPDATE_PARTICIPANT_EMAIL_ERROR = 'UPDATE_PARTICIPANT_EMAIL_ERROR';
export const CLEAR_UPDATE_PARTICIPANT_EMAIL_ERROR = 'CLEAR_UPDATE_PARTICIPANT_EMAIL_ERROR';
export const UPDATE_PARTICIPANT_EMAIL_LOADING = 'UPDATE_PARTICIPANT_EMAIL_LOADING';

export const UPDATED_PARTICIPANT_GENDER = 'UPDATED_PARTICIPANT_GENDER';
export const UPDATE_PARTICIPANT_GENDER_ERROR = 'UPDATE_PARTICIPANT_GENDER_ERROR';
export const CLEAR_UPDATE_PARTICIPANT_GENDER_ERROR = 'CLEAR_UPDATE_PARTICIPANT_GENDER_ERROR';
export const UPDATE_PARTICIPANT_GENDER_LOADING = 'UPDATE_PARTICIPANT_GENDER_LOADING';

export const UPDATED_PARTICIPANT_BIRTHDATE = 'UPDATED_PARTICIPANT_BIRTHDATE';
export const UPDATE_PARTICIPANT_BIRTHDATE_ERROR = 'UPDATE_PARTICIPANT_BIRTHDATE_ERROR';
export const UPDATE_PARTICIPANT_BIRTHDATE_LOADING = 'UPDATE_PARTICIPANT_BIRTHDATE_LOADING';

export const UPDATED_PARTICIPANT_ADDRESS = 'UPDATED_PARTICIPANT_ADDRESS';
export const UPDATE_PARTICIPANT_ADDRESS_ERROR = 'UPDATE_PARTICIPANT_ADDRESS_ERROR';
export const UPDATE_PARTICIPANT_ADDRESS_LOADING = 'UPDATE_PARTICIPANT_ADDRESS_LOADING';
export const FETCHING_REPORTS = 'FETCHING_REPORTS';
export const FETCHED_REPORTS = 'FETCHED_REPORTS';
export const FETCH_REPORTS_ERROR = 'FETCH_REPORTS_ERROR';
export const FETCH_QLIK_SESSION_ERROR = 'FETCH_QLIK_SESSION_ERROR';
export const FETCHED_REPORTS_STATUS = 'FETCHED_REPORTS_STATUS';
export const FETCHED_REPORTS_STATUS_ERROR = 'FETCHED_REPORTS_STATUS_ERROR';
export const FETCHED_SIGNED_CONSENTINGS_NO = 'FETCHED_SIGNED_CONSENTINGS_NO';
export const FETCHED_SIGNED_CONSENTINGS_NO_ERROR = 'FETCHED_SIGNED_CONSENTINGS_NO_ERROR';
export const INITIATED_EXPORT_PARTICIPANT_ARCHIVE = 'INITIATED_EXPORT_PARTICIPANT_ARCHIVE';
export const INITIATED_EXPORT_PARTICIPANT_ARCHIVE_ERROR = 'INITIATED_EXPORT_PARTICIPANT_ARCHIVE_ERROR';
export const RESET_INITIATED_EXPORT_PARTICIPANT_ARCHIVE = 'RESET_INITIATED_PARTICIPANT_ARCHIVE';
export const GET_EXPORT_ARCHIVE_STATUS = 'GET_EXPORT_ARCHIVE_STATUS';
export const GET_EXPORT_ARCHIVE_STATUS_ERROR = 'GET_EXPORT_ARCHIVE_STATUS_ERROR';

export const FETCHING_CONSENT_DOCUMENTS_FOR_SOP = 'FETCHING_CONSENT_DOCUMENTS_FOR_SOP';
export const FETCHED_CONSENT_DOCUMENTS_FOR_SOP = 'FETCHED_CONSENT_DOCUMENTS_FOR_SOP';
export const FETCH_CONSENT_DOCUMENTS_FOR_SOP_ERROR = 'FETCH_CONSENT_DOCUMENTS_FOR_SOP_ERROR';
export const CLEAR_CONSENT_DOCUMENTS_FOR_SOP = 'CLEAR_CONSENT_DOCUMENTS_FOR_SOP';
export const FETCHED_CONSENTING_OPTIN_STATE_FOR_SOP = 'FETCHED_CONSENTING_OPTIN_STATE_FOR_SOP';

export const FETCHING_CONSENT_DOCUMENTS_4_SOP_CHANGE_ANSWERS = 'FETCHING_CONSENT_DOCUMENTS_4_SOP_CHANGE_ANSWERS';
export const FETCHED_CONSENT_DOCUMENTS_4_SOP_CHANGE_ANSWERS = 'FETCHED_CONSENT_DOCUMENTS_4_SOP_CHANGE_ANSWERS';
export const SHOW_ERROR_4_SOP_CHANGE_ANSWERS = 'SHOW_ERROR_4_SOP_CHANGE_ANSWERS';
export const CLEAR_CONSENT_DOCUMENTS_4_SOP_CHANGE_ANSWERS = 'CLEAR_CONSENT_DOCUMENTS_4_SOP_CHANGE_ANSWERS';
export const FETCHED_CONSENTING_OPTIN_STATE_4_SOP_CHANGE_ANSWERS =
  'FETCHED_CONSENTING_OPTIN_STATE_4_SOP_CHANGE_ANSWERS';
export const SET_CONSENTING = 'SET_CONSENTING';
export const ID_PORTAL_MIGRATION_STATE_UPDATE = 'ID_PORTAL_MIGRATION_STATE_UPDATE';
